import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  styled,
  Typography,
} from "@mui/material";
import { StyledModalBox } from "@/components/styled";
import SVGWarningModal from "@/assets/icons/SVGWarningModal.tsx";

type Props = {
  title: string;
  subtitle: string;
  onClose: () => void;
  onClick?: () => void;
  buttonText?: string;
  closeButtonText?: string;
  nextButtonVariant?: "contained" | "danger";
  loading?: boolean;
};

export const TitleTypography = styled(Typography)(({ theme }) => ({
  marginTop: "32px",
  textAlign: "center",
  fontSize: "28px",
  fontWeight: 600,
  [theme.breakpoints.down("lg")]: {
    fontSize: "24px",
    fontWeight: 500,
  },
}));

const NextStepModal = ({
  title,
  subtitle,
  onClose,
  buttonText,
  onClick,
  closeButtonText = "Cancel",
  nextButtonVariant = "contained",
  loading = false,
}: Props) => {
  return (
    <StyledModalBox>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <SVGWarningModal />
        <TitleTypography sx={{ marginTop: "32px" }}>{title}</TitleTypography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 400,
            marginTop: "12px",
            textAlign: "center",
          }}
        >
          {subtitle}
        </Typography>
        <Box
          sx={{
            marginTop: "32px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "100%",
          }}
        >
          {onClick && (
            <Button
              variant={nextButtonVariant}
              sx={{ width: "100%" }}
              onClick={onClick}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                buttonText
              )}
            </Button>
          )}
          <Button
            variant={"outlined"}
            sx={{ width: "100%" }}
            onClick={onClose}
            disabled={loading}
          >
            {closeButtonText}
          </Button>
        </Box>
      </Box>
    </StyledModalBox>
  );
};

export default NextStepModal;
